export default __webpack_public_path__ + "static/media/workplace.9a9ca6ed.svg";